import React, { useEffect, useState } from "react";
import logo from '../img/logo.png';
import '../css/Login.css';
import { IonIcon } from '@ionic/react';
import Swal from 'sweetalert';
import { wifiOutline, batteryFullOutline, cellularOutline, arrowBack, eye, eyeOff } from 'ionicons/icons';
import { Link, useNavigate, useLocation } from 'react-router-dom';

// IMPORTAR FUNÇÕES
import { db, auth, ANO, entrarComServidor, logarResponsavel, logarServidor, cadastrar } from '../firebase/logar';


const reload = () => {
    window.location.reload();
}

const Redefinir = () => {

    const navigate = useNavigate();
    const location = useLocation();

    // ITERAÇÃO COM O USUARIO
    const [horaAtual, setHoraAtual] = useState(new Date());
    const [mostrarMdRedefinirSenha, setMdRedefinirSenha] = useState(true);
    const [carregamento, setCarregamento] = useState(false);
    
    useEffect(() => {
        const intervalId = setInterval(() => {
            setHoraAtual(new Date());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);
    const horas = formatDigit(horaAtual.getHours());
    const minutos = formatDigit(horaAtual.getMinutes());
    const segundos = formatDigit(horaAtual.getSeconds());
    
    // INPUT CADASTRAR
    const [redefinirSenhaSenha, setInputRedefinirSenhaSenha] = useState('');
    const [codigo, setCodigo] = useState('');

    const storageResponsavel = localStorage.getItem('responsavel');
    const responsavel = storageResponsavel ? storageResponsavel : null; 

    // ADICIONAR SERIES
    const listaSeries = localStorage.getItem('series');
    const series = listaSeries ? JSON.parse(listaSeries) : [];

    function capitalizar(val) {
        var texto = val;
        // Verifica se a entrada não está vazia
        if (texto.length === 0) {
          return texto;
        }
        // Divide a string em palavras
        var palavras = texto.split(' ');
        // Capitaliza a primeira letra de cada palavra
        for (var i = 0; i < palavras.length; i++) {
          palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1).toLowerCase();
        }
        // Junta as palavras de volta em uma única string
        var resultado = palavras.join(' ');
        resultado = resultado.replace(/\s+/g, ' ');
        resultado = resultado.trim();
  
        return resultado;
      }


    const handleEnviarRedefinirSenha = async () => {
        setCarregamento(true);
        try {
            if (redefinirSenhaSenha && redefinirSenhaSenha.length >= 6) {
                const resposta = await redefinirSenhaComCodigo(codigo, redefinirSenhaSenha);
                if (resposta) {
                    setCarregamento(false);
                } else {
                    setCarregamento(false);
                }
            } else {
                Swal({
                    title: 'Digite uma senha com mais de 6 dígitos!',
                    icon: 'error',
                    buttons: {
                    confirm: 'Ok',
                    },
                });
                setCarregamento(false);
            }
        } catch (error) {
            console.log(error);    
        }
        
        
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const codigoVerificacao = urlParams.get('oobCode');
    
        if (codigoVerificacao) {
            // Chame aqui a função ou serviço para redefinir a senha usando o código de verificação
            setCodigo(codigoVerificacao);
            console.log('Código de verificação:', codigoVerificacao);
        } else {
            navigate('/login/');
        }
      }, [location.search]);

    const redefinirSenhaComCodigo = async (codigo, novaSenha) => {
        
        const redefinir = new Promise( async (resolve, reject) => {
            try {
                await auth.confirmPasswordReset(codigo, novaSenha)
                .then(() => {
                    setCarregamento(false);
                    Swal({
                        title: 'Senha redefinida com sucesso!',
                        icon: 'success',
                        buttons: {
                        confirm: 'Ok',
                        },
                    }).then( async (res) => {
                        const responsavelRef = await db.collection(ANO)
                        .doc('responsaveis')
                        .collection(responsavel)
                        .doc(responsavel);
                        
                        await responsavelRef.get()
                        .then((val) => {
                            console.log(val.data());
                            if (val.data()) {
                                responsavelRef.update({
                                    senha: novaSenha,
                                });
                                localStorage.setItem('senha', novaSenha);
                            }
                        });

                        window.location.href = "/logar/";
                    });
                })
                .catch((error) => {
                    console.error('Erro ao redefinir senha com código:', error.message);
                    // Tratar o erro de alguma forma (ex: exibir uma mensagem para o usuário)
                });
            } catch (error) {
                console.log(error);    
            }
        });

        return redefinir;
        
      };

    return (
        <main className="container-login">
            
            <div className="before">
                <p id="hora">
                    {horas}:{minutos}:{segundos}
                </p>
                <div className="flex">
                    <IonIcon icon={wifiOutline} />
                    <IonIcon icon={cellularOutline} />
                    <IonIcon icon={batteryFullOutline} />
                </div>
            </div>
            
            {mostrarMdRedefinirSenha && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1>Redefinir senha da sua conta</h1>
                        </div>
                    </section>
                    <section className="content-login">
                        <div className="form-tecvit form-login">
                            
                            <div className="flex">
                                <input onChange={(e) => setInputRedefinirSenhaSenha(capitalizar(e.target.value))} placeholder=" " type="text" />    
                                <label>Digite sua nova senha</label>
                            </div>

                            <div className="flex">
                                <button onClick={handleEnviarRedefinirSenha}>
                                    {carregamento ? (
                                        <div className="icon-carregamento"></div>
                                    ) : (
                                        <>Redefinir Senha</>
                                    )}
                                </button>
                            </div>

                            <div className="termosGerais">
                                <p>
                                    Ao usar o aplicativo você concorda com os
                                    <br />
                                    <Link to="/security/termos">
                                        <a> Termos de Uso </a>
                                    </Link>
                                    e
                                    <Link to="/security/privacidade">
                                      <a> Política de Privacidade </a>
                                    </Link>
                                </p>
                            </div>

                        </div>
                    </section>
                </div>
            )}

        </main>
    );
}

export default Redefinir;